export const COMMON_COMPLETION = [
  // 完整Cube结构 (最高优先级)
  { 
    name: 'cube', 
    value: '- name: ${1:cube_name}\n  data_source: ${2:data_source}\n  sql_table: ${3:table_name}\n  description: "${4}"\n  joins: []\n  dimensions:\n    - name: ${5:dimension_name}\n      type: ${6:string|number|time}\n      sql: \'{CUBE}.${7:column_name}\'\n      original_type: ${8:STRING|INT64|DATETIME|etc}\n  measures:\n    - name: count\n      description: "Count of records"\n      sql: count(1)\n      type: number', 
    meta: 'Complete cube definition', 
    score: 100 
  },

  // 基础结构
  { 
    name: 'cubes', 
    value: 'cubes:\n  - name: ${1}\n    data_source: ${2}\n    sql_table: ${3}\n    description: "${4}"', 
    meta: 'Cubes root definition', 
    score: 95 
  },

  // 维度类型 (高优先级)
  { 
    name: 'string_dimension', 
    value: '- name: ${1:dimension_name}\n  type: string\n  sql: \'{CUBE}.${2:column_name}\'\n  original_type: STRING', 
    meta: 'String dimension', 
    score: 90 
  },
  { 
    name: 'time_dimension', 
    value: '- name: ${1:dimension_name}\n  type: time\n  sql: \'{CUBE}.${2:column_name}\'\n  original_type: DATETIME', 
    meta: 'Time dimension', 
    score: 90 
  },
  { 
    name: 'number_dimension', 
    value: '- name: ${1:dimension_name}\n  type: number\n  sql: \'{CUBE}.${2:column_name}\'\n  original_type: INT64', 
    meta: 'Number dimension', 
    score: 90 
  },
  { 
    name: 'array_dimension', 
    value: '- name: ${1:dimension_name}\n  type: string\n  sql: \'{CUBE}.${2:column_name}\'\n  original_type: ARRAY<STRING>', 
    meta: 'Array dimension', 
    score: 85 
  },

  // 度量类型 (高优先级)
  { 
    name: 'count_measure', 
    value: '- name: count\n  description: "Count of records"\n  sql: count(1)\n  type: number', 
    meta: 'Count measure', 
    score: 90 
  },
  { 
    name: 'sum_measure', 
    value: '- name: ${1:measure_name}\n  description: "${2}"\n  sql: sum(${CUBE}.${3:column_name})\n  type: number', 
    meta: 'Sum measure', 
    score: 85 
  },

  // 立方体属性 (中优先级)
  { 
    name: 'name', 
    value: 'name: ${1}', 
    meta: 'Cube/dimension/measure name', 
    score: 80 
  },
  { 
    name: 'data_source', 
    value: 'data_source: ${1:data_source_name}', 
    meta: 'Data source', 
    score: 80 
  },
  { 
    name: 'sql_table', 
    value: 'sql_table: ${1:table_name}', 
    meta: 'SQL table', 
    score: 80 
  },
  { 
    name: 'description', 
    value: 'description: "${1}"', 
    meta: 'Description', 
    score: 75 
  },

  // 连接定义 (中优先级)
  { 
    name: 'joins', 
    value: 'joins:\n  - name: ${1:join_name}\n    sql: ${2:join_condition}\n    relationship: ${3:belongs_to|has_many|has_one}', 
    meta: 'Join definition', 
    score: 70 
  },

  // 维度/度量属性 (中优先级)
  { 
    name: 'type', 
    value: 'type: ${1:string|number|time}', 
    meta: 'Data type', 
    score: 70 
  },
  { 
    name: 'sql', 
    value: 'sql: \'{CUBE}.${1:column_name}\'', 
    meta: 'SQL expression', 
    score: 70 
  },
  { 
    name: 'original_type', 
    value: 'original_type: ${1:STRING|INT64|DATETIME|ARRAY<STRING>}', 
    meta: 'Original database type', 
    score: 70 
  },

  // 常见原始类型 (低优先级)
  { 
    name: 'STRING_type', 
    value: 'original_type: STRING', 
    meta: 'String type', 
    score: 60 
  },
  { 
    name: 'INT64_type', 
    value: 'original_type: INT64', 
    meta: 'Integer type', 
    score: 60 
  },
  { 
    name: 'DATETIME_type', 
    value: 'original_type: DATETIME', 
    meta: 'Datetime type', 
    score: 60 
  },
  { 
    name: 'ARRAY_type', 
    value: 'original_type: ARRAY<${1:STRING}>', 
    meta: 'Array type', 
    score: 60 
  },

  // 基础YAML结构 (最低优先级)
  { 
    name: 'key-value', 
    value: '${1:key}: ${2:value}', 
    meta: 'Key-value pair', 
    score: 50 
  },
  { 
    name: 'list', 
    value: '${1:list}:\n  - ${2:item1}\n  - ${3:item2}', 
    meta: 'List', 
    score: 40 
  }
];